import { render, staticRenderFns } from "./DataLabel.vue?vue&type=template&id=4f8c7512&"
import script from "./DataLabel.vue?vue&type=script&lang=js&"
export * from "./DataLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports